// ** MUI Imports
import Box from '@mui/material/Box'
import IconButton from '@mui/material/IconButton'

// ** Icons Imports
import MenuIcon from 'mdi-material-ui/Menu'

// ** Type Import
import { Settings } from 'src/@core/context/settingsContext'
import Calendar from 'mdi-material-ui/Calendar'

// ** Components
import Autocomplete from 'src/layouts/components/Autocomplete'

// import ModeToggler from 'src/@core/layouts/components/shared-components/ModeToggler'
import UserDropdown from 'src/@core/layouts/components/shared-components/UserDropdown'

//import NotificationDropdown from 'src/@core/layouts/components/shared-components/NotificationDropdown'
import HelpDesk from 'src/@core/layouts/components/shared-components/HelpDesk'
import { useRouter } from 'next/router'

interface Props {
  hidden: boolean
  settings: Settings
  toggleNavVisibility: () => void
  saveSettings?: (values: Settings) => void
}

const AppBarContent = (props: Props) => {
  // ** Props
  const { hidden, settings, toggleNavVisibility } = props
  const router = useRouter()
  const isGlobalCalendar = router.pathname.includes('/global-calendar')

  return (
    <Box sx={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
      <Box className='actions-left' sx={{ mr: 2, display: 'flex', alignItems: 'center' }}>
        {hidden ? (
          <IconButton color='inherit' sx={{ ml: -2.75 }} onClick={toggleNavVisibility}>
            <MenuIcon />
          </IconButton>
        ) : null}
        {!isGlobalCalendar && <Autocomplete hidden={hidden} settings={settings} />}
      </Box>

      <Box sx={{ display: 'inline-flex', alignItems: 'center' }}>
        <Box
          sx={{ display: 'flex', alignItems: 'center', gap: 2, cursor: 'pointer', mr: 3 }}
          onClick={() => router.push('/global-calendar')}
        >
          <Calendar />
          Calendar
        </Box>
        <Box className='actions-right' sx={{ display: 'flex', alignItems: 'center', boxShadow: 2, padding: 1 }}>
          <HelpDesk settings={settings} />
          {/* <NotificationDropdown settings={settings} /> */}
          <UserDropdown settings={settings} />
        </Box>
      </Box>
    </Box>
  )
}

export default AppBarContent
